import React, { useContext } from "react";
import { Link } from "react-router-dom";
import {
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarFooter,
  CDBSidebarHeader,
  CDBSidebarMenu,
  CDBSidebarMenuItem,
} from "cdbreact";
import { NavLink } from "react-router-dom";
import { IoMdExit } from "react-icons/io";
import { UserContext } from "../Context";

const Sidebar = () => {
  const user = useContext(UserContext);

  return (
    <div
      style={{ display: "flex", height: "100vh", overflow: "scroll initial" }}
    >
      <CDBSidebar textColor="#fff" backgroundColor="#333">
        <CDBSidebarHeader prefix={<i className="fa fa-bars fa-large"></i>}>
          <a
            href="/"
            className="text-decoration-none"
            style={{ color: "inherit" }}
          >
            Ummat Production
          </a>
        </CDBSidebarHeader>

        <CDBSidebarContent className="sidebar-content">
          <CDBSidebarMenu>
            <NavLink exact to="/auth/dashboard" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="columns">Dashboard</CDBSidebarMenuItem>
            </NavLink>
            {user.role === "admin" ? (
              <>
                <NavLink
                  exact
                  to="/auth/usermanagement"
                  activeClassName="activeClicked"
                >
                  <CDBSidebarMenuItem>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-person-fill-gear"
                      viewBox="0 0 16 16"
                      style={{ marginLeft: "0.1rem", marginRight: "1.1rem" }}
                    >
                      <path d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-9 8c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4m9.886-3.54c.18-.613 1.048-.613 1.229 0l.043.148a.64.64 0 0 0 .921.382l.136-.074c.561-.306 1.175.308.87.869l-.075.136a.64.64 0 0 0 .382.92l.149.045c.612.18.612 1.048 0 1.229l-.15.043a.64.64 0 0 0-.38.921l.074.136c.305.561-.309 1.175-.87.87l-.136-.075a.64.64 0 0 0-.92.382l-.045.149c-.18.612-1.048.612-1.229 0l-.043-.15a.64.64 0 0 0-.921-.38l-.136.074c-.561.305-1.175-.309-.87-.87l.075-.136a.64.64 0 0 0-.382-.92l-.148-.045c-.613-.18-.613-1.048 0-1.229l.148-.043a.64.64 0 0 0 .382-.921l-.074-.136c-.306-.561.308-1.175.869-.87l.136.075a.64.64 0 0 0 .92-.382zM14 12.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0" />
                    </svg>
                    User management
                  </CDBSidebarMenuItem>
                </NavLink>
                <NavLink
                  exact
                  to="/auth/analytics"
                  activeClassName="activeClicked"
                >
                  <CDBSidebarMenuItem icon="chart-line">
                    Analytics
                  </CDBSidebarMenuItem>
                </NavLink>
              </>
            ) : (
              <NavLink exact to="/auth/profile" activeClassName="activeClicked">
                <CDBSidebarMenuItem icon="user">Profile</CDBSidebarMenuItem>
              </NavLink>
            )}
            <NavLink exact to="/auth/upload" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="upload">Upload</CDBSidebarMenuItem>
            </NavLink>
            <NavLink exact to="/auth/contents" activeClassName="activeClicked">
              <CDBSidebarMenuItem icon="edit">
                Manage Contents
              </CDBSidebarMenuItem>
            </NavLink>
          </CDBSidebarMenu>
        </CDBSidebarContent>

        <CDBSidebarFooter
          style={{
            textAlign: "center",
            transform: "translateY(-1rem)",
          }}
        >
          <Link to="/logout" style={{ textDecoration: "none", color: "white" }}>
            <IoMdExit
              style={{
                transform: "translateY(-0.1rem)",
                marginRight: "0.5em",
                width: "1.3em",
                height: "1.3em",
              }}
            />
            Log out
          </Link>
        </CDBSidebarFooter>
      </CDBSidebar>
    </div>
  );
};

export default Sidebar;
